import apiRequestService from '@/commonProject/service/apiRequestService';

export default class ReserveRepository {
    /**
     * イシュー一覧取得API
     * @param {*} requestBody
     * @returns result
     */
    async getIssueApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvisulst', requestBody, idToken);
        return result;
    }
    /**
     * 利用方法一覧取得API
     * @param {*} requestBody
     * @returns result
     */
    async getManegmentApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvmetlst', requestBody, idToken);
        return result;
    }
    /**
     * 言語一覧取得API
     * @param {*} requestBody
     * @returns result
     */
    async getLanguageApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvlnglst', requestBody, idToken);
        return result;
    }
    /**
     * 予約方法一覧取得API
     * @param {*} requestBody
     * @returns result
     */
    async getTabListApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvrsvlst', requestBody, idToken);
        return result;
    }
    /**
     * サービス一覧取得API
     * @param {*} requestBody
     * @returns result
     */
    async getReserveServiceApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvsvclst', requestBody, idToken);
        return result;
    }
    /**
     * サービス詳細取得API
     * @param {*} queryParam
     * @returns result
     */
    async getServiceDetailApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/svcdtl', queryParam, idToken);
        return result;
    }
    /**
     * 規定詳細取得API
     * @param {*} requestBody
     * @returns result
     */
    async getRegulationDetailApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/regdtl', requestBody, idToken);
        return result;
    }
    /**
     * 予約一覧取得API
     * @param {*} requestBody
     * @returns
     */
    async getReserveListApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvlst', requestBody, idToken);
        return result;
    }
    /**
     * 予約詳細取得API
     * @param {*} requestBody
     * @returns
     */
    async getReserveDetailApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/rsvdtl', requestBody, idToken);
        return result;
    }

    /**
     * 予約カレンダー施設一覧取得API
     * @param {*} req
     * @returns result
     */
    async getCalendarRoomApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvcalromlst', requestBody, idToken);

        return result;
    }
    /**
     * 予約カレンダー日付一覧取得API
     * @param {*} req
     * @returns result
     */
    async getCalendarDayApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvcaldatlst', requestBody, idToken);

        return result;
    }
    /**
     * 予約カレンダー時刻一覧取得API
     * @param {*} req
     * @returns result
     */
    async getCalendarTimeApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvcaltimlst', requestBody, idToken);

        return result;
    }
    /**
     * 予約アレンジ地域一覧取得API
     * @param {*} req
     * @returns result
     */
    async getArrangeRegionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvargrgnlst', requestBody, idToken);

        return result;
    }
    /**
     * 予約アレンジ地区一覧取得API
     * @param {*} req
     * @returns result
     */
    async getArrangeAreaApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvargaralst', requestBody, idToken);

        return result;
    }

    /**
     * 予約アレンジ日付一覧取得API
     * @param {*} requestBody
     * @returns result
     */
    async getArrangeDayApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/rsvargdatlst', requestBody, idToken);
        return result;
    }

    /**
     * 予約登録API
     * @param {*} requestBody
     * @returns
     */
    async getReserveCreateApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + `/rsvdtl`, requestBody, idToken);
        return result;
    }

    /**
     * 予約更新API
     * @param {*} req
     * @returns
     */
    async getReserveUpdateApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + `/rsvdtl`, requestBody, idToken);
        return result;
    }

    /**
     * セッショングループ詳細取得API
     * @param {*} req
     * @returns result
     */
    async getSessionGroupDetailApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + `/sgrdtl`, queryParam, idToken);

        return result;
    }

    /**
     * 予約取消API
     * @param {*} req
     * @returns
     */
    async getReserveDeleteApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerDelete(API_URL + `/rsvdtl`, requestBody, idToken);

        return result;
    }
}
